// Single source of truth for a location/account's own id. Billing-service rows
// share the account-wide EAID in `.code` across the parent and every child, so
// their per-entity id is `.id`; other shapes use `.code`.
export const resolveLocationAccountId = loc =>
  loc?.thryvId ||
  loc?.thryvID ||
  (loc?._fromBillingService ? loc?.id : loc?.code || loc?.id)
